import "./App.css"
import "@radix-ui/themes/styles.css"
import { Auth } from "./auth/Auth"
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom"
import { Home } from "./components/Home/Home"
import { FC, useEffect } from "react"
import { NotificationService } from "./features/NotificationService/NotificationService"
import { useAppDispatch } from "./app/hooks"
import { SysApi } from "./api/sysapi"
import { WSocketService } from "./app/services/ws/WSocketService"
import { Theme } from "@radix-ui/themes"
import { fetchWBTokenStatus } from "./app/reducers/wbTokenSlice"

const App: FC = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    const token = localStorage.getItem("token")
    if (!token && location.pathname !== "/login") {
      location.replace("/login")
    }
  }, [])

  useEffect(() => {
    const token = localStorage.getItem("token")
    WSocketService.connect(SysApi.baseUrl)
    if (token) {
      dispatch(fetchWBTokenStatus())
    }
    return () => {
      WSocketService.disconnect()
    }
  }, [dispatch])

  const token = localStorage.getItem("token")
  if (!token && location.pathname !== "/login") {
    return null
  }

  return (
    <Theme>
      <main className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/:activeTab?/:activeSubTab?" element={<Home />} />
            <Route path="login" element={<Auth />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <div id={"loader"}></div>
        <NotificationService />
      </main>
    </Theme>
  )
}

export default App
